<template>
  <div class="mb--2">
    <span class="txt--upper txt--strong txt--sm d--b">{{ title }}</span>
    <p v-if="value != null">{{ value }}</p>
    <p v-if="html != null" v-html="html"></p>
  </div>
</template>

<script>
export default {
  props: ["title", "value", "html"]
};
</script>
